import type { ApiResponse, Client, PaginatedResponse } from '@/types/api';

import { api } from './api';

export const clientService = {
  list: async (params?: Record<string, unknown> & { includeInactive?: boolean; userId?: number }) => {
    const queryParams: Record<string, unknown> = { ...params };
    if (queryParams.userId) {
      queryParams.userId = queryParams.userId;
    }
    const response = await api.get<PaginatedResponse<Client>>('/clients', {
      params: {
        ...queryParams,
        includeInactive: queryParams.includeInactive ? 'true' : undefined,
      },
    });
    return response.data;
  },
  create: async (payload: Partial<Client>) => {
    const response = await api.post<ApiResponse<Client>>('/clients', payload);
    return response.data.data;
  },
  update: async (id: number, payload: Partial<Client>) => {
    const response = await api.put<ApiResponse<Client>>(`/clients/${id}`, payload);
    return response.data.data;
  },
  remove: async (id: number) => {
    const response = await api.delete(`/clients/${id}`);
    return response.data;
  },
  activate: async (id: number) => {
    const response = await api.put<ApiResponse<Client>>(`/clients/${id}/activate`);
    return response.data.data;
  },
  getUpcomingBirthdays: async (days?: number) => {
    const response = await api.get<ApiResponse<Client[]>>('/clients/upcoming-birthdays', {
      params: days ? { days } : undefined,
    });
    return response.data.data;
  },
  listAll: async (params?: Record<string, unknown>) => {
    const response = await api.get<ApiResponse<Client[]>>('/clients/all', { params });
    return response.data.data;
  },
  permanentDelete: async (id: number, password: string) => {
    const response = await api.delete(`/clients/${id}/permanent`, { data: { password } });
    return response.data;
  },
};
